import React, { useContext, useEffect, useState } from 'react';
import Joyride from 'react-joyride';
import AppColors from '../constants/AppColors';
import { AuthContext } from '../providers/AuthProvider';

const AppTour = ({ }) => {
  const accountContext = useContext(AuthContext);
  const [tourKey, setTourKey] = useState(0);

  useEffect(() => {
    if (accountContext.runTour) {
      setTourKey((prevKey) => prevKey + 1);
    }
  }, [accountContext.runTour]);

  const steps = [
    { target: '#tour-upload', content: 'Click here to upload your files.', disableBeacon: true },
    { target: '#tour-mycharts', content: 'See history of all your past uploads here.' },
    {
      target: '#tour-date-filter', content: 'Use this filter to change the date range.',
      styles: {
        spotlight: {
          transform: 'scaleX(1) ',
        },
      },
    },
    {
      target: '#tour-icon-rvu', content: 'For more information on each tile, press the “i” icon in the top right corner.',
      styles: {
        spotlight: {
          transform: 'scaleX(1) ',
        },
      },
    },
    {
      target: '#tour-account-menu-wrapper',
      content: 'To access account or practice info navigate here.',
      placement: 'left',
      styles: {
        spotlight: {
          transform: 'scaleX(0.9) translateX(-4%)',
        },
      },
    },
    {
      target: '#tour-revenue-health', 
      content: 'Gain a broad understanding of overall revenue health, using these top tiles.​',
      styles: {
        spotlight: {
          transform: 'scaleX(1)',
        },
      },
    },
    {
      target: '#tour-revenue-opportunity', 
      content: 'These tiles can be used to gain a better understanding of potential revenue opportunities.​',
      styles: {
        spotlight: {
          transform: 'scaleX(1)',
        },
      },
    },
    { target: '#tour-help', content: 'Need help? Click here for support.' },
  ];


  const handleJoyrideCallback = (data) => {
    const { status, index } = data;
    if (status === 'running') {
      const menuButton = document.querySelector('#tour-account-menu-wrapper button');

      if (index === 4) {
        if (menuButton) {
          const isMenuOpen = menuButton.getAttribute('aria-expanded') === 'true';
          if (!isMenuOpen) {
            menuButton.click();
          }
        }
      } else {
        if (menuButton && menuButton.getAttribute('aria-expanded') === 'true') {
          menuButton.click();
        }
      }
    }

    if (status === 'finished' || status === 'skipped') {
      const menuButton = document.querySelector('#tour-account-menu-wrapper button');
      if (menuButton && menuButton.getAttribute('aria-expanded') === 'true') {
        menuButton.click();
      }
      setTimeout(() => {
        accountContext.setRunTour(false);
      }, 100);
    }
  };

  return (
    <Joyride
      key={tourKey}
      steps={steps}
      run={accountContext.runTour}
      continuous={true}
      scrollToFirstStep={true}
      showProgress={true}
      showSkipButton={true}
      disableOverlayClose={true}
      styles={{
        options: {
          primaryColor: AppColors.primary,
          backgroundColor: '#fff',
          textColor: '#333',
          arrowColor: AppColors.primary,
          overlayColor: 'rgba(0, 0, 0, 0.4)',
          zIndex: 1000,
        },
        buttonClose: { display: 'none' },
        buttonNext: { backgroundColor: AppColors.secondary },
        buttonBack: { color: AppColors.secondary },
        spotlight: {
          borderRadius: '15px',
          backgroundColor: 'rgba(255, 255, 255, 0.3)',
          boxShadow: '0 0 15px rgba(0, 0, 0, 0.3)',
          transform: 'scale(0.8)',
        },
        modal: { transition: 'all 1s ease-in-out' },
        beacon: {
          animation: 'pulse 1.5s infinite',
        },
      }}
      callback={handleJoyrideCallback}
      locale={{
        last: "Finish", // Change "Last" to "Finish"
      }}
    />
  );
};

export default AppTour;